const data = [
    {
        id: 1,
        name: "Akshay Kumar",
        age: "53",
        birthdate: "9 Sep 1967",
        image: "https://a1png.com/wp-content/uploads/2020/09/Akshy-kumar-9-2.png"
    },
    {
        id: 2,
        name: "Raj Kumar Rao",
        age: "36",
        birthdate: "31 Aug 1984",
        image: "https://i.pinimg.com/736x/90/c9/ca/90c9ca01b2778992bc11a6d65fc49746.jpg"
    },
    {
        id: 3,
        name: "Pankaj Tripathi",
        age: "44",
        birthdate: "5 Sep 1976",
        image: "https://assets.telegraphindia.com/telegraph/933b039a-bc48-47b6-9041-bf87e3c58511.jpg"
    },
    {
        id: 4,
        name: "Manoj Bajpayee",
        age: "52",
        birthdate: "23 April 1969",
        image: "https://i2.cinestaan.com/image-bank/1500-1500/126001-127000/126942.jpg"
    },
    {
        id: 5,
        name: "Nawazuddin Siddiqui",
        age: "47",
        birthdate: "19 Sep 1974",
        image: "https://cdn.pngsumo.com/download-hd-about-nawazuddin-nawazuddin-siddiqui-face-png-nawazuddin-siddiqui-png-316_548.png"
    }
];

export default data;